<div class="header-container">
    <div class="left-wrapper">
        <div class="pagetitle">SISU Foto</div>
    </div>
    <span>
        <div class="right-wrapper some-icons-inline" style="align: right">
            <div class="anchorlink" (click)="soMeClick( 'Instagram', 'https://instagram.com/sisufoto' )"><img src="assets/some/icons8-instagram-48.svg"/></div>
            <div class="anchorlink" (click)="soMeClick( 'Facebook','https://facebook.com/sisufotos' )"><img src="assets/some/icons8-facebook-48.svg"/></div>
            <div class="anchorlink" (click)="soMeClick( 'YouTube','https://www.youtube.com/@SISU-Foto' )"><img src="assets/some/icons8-youtube-48.svg"/></div>
        </div>
        <div style="text-align: right">
            <div>
                <app-licensing></app-licensing>
            </div>
            <div style="align: right">&copy; Anders R. Bystrup <a class="contact" target="_blank" href="mailto:anders+sisu@bystrup.net?subject=SISU Foto">anders&#64;sisufoto.dk</a></div>
        </div>
        </span>
</div>
